<main class="page-container">
  @if (loadingPage) {
    <app-loading [fullscreen]="true" label="Cargando usuarios..."></app-loading>
  }
  <app-page-header
    title="Usuarios"
    description="Consulta y administra los usuarios registrados en la plataforma"
  >
    <app-button type="button" variant="primary" size="large" (clicked)="nuevaUsuario()">
      <i class="fa-solid fa-plus"></i>
      Nuevo usuario
    </app-button>
  </app-page-header>

  <div class="summary-grid">
    <app-summary-card
      label="Usuarios registrados"
      [value]="infoUsuarios?.usuariosRegistrados?.toString() || null"
      icon="fa-solid fa-users"
      tone="blue"
    />
    <app-summary-card
      label="Usuarios sin rol"
      [value]="infoUsuarios?.usuariosSinRol?.toString() || null"
      icon="fa-solid fa-user-slash"
      tone="warning"
    />
    <app-summary-card
      label="Registrados este mes"
      [value]="infoUsuarios?.usuariosEsteMes?.toString() || null"
      icon="fa-solid fa-user-plus"
      tone="green"
    />
  </div>

  <section class="data-section-card usuarios-card">
    <div class="toolbar">
      <app-search-input
        class="wide-search"
        placeholder="Buscar por empresa o nombre..."
        [(value)]="searchInput"
        (search)="onSearch()"
      />
      <app-select
        [value]="statusFilter"
        [options]="statusOptions"
        aria-label="Filtrar por estado"
        (valueChange)="onStatusChange($event)"
      />
    </div>

    @if (mobileService.isMobile()) {
      <app-card-list
        [items]="data"
        [loading]="loadingTable"
        [emptyMessage]="'No hay usuarios registrados.'"
        [showPagination]="true"
        [page]="page"
        [pageSize]="pageSize"
        [totalItems]="totalItems"
        [pageSizeOptions]="[10, 25, 50, 100]"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      >
        <ng-template #card let-usuario>
          <div class="card-list-item">
            <div class="card-list-item-header usuario-card-header">
              <div class="usuario-card-identity">
                <strong>{{ usuario.nombre }}</strong>
                <span>{{ usuario.usuario }}</span>
              </div>
            </div>

            <div class="card-list-item-body">
              <div class="card-list-item-details">
                <span class="card-list-item-label"
                  >Empresa:
                  <span class="card-list-item-value">
                    {{ usuario.empresa || 'Sin empresa' }}
                  </span>
                </span>
                <span class="card-list-item-label"
                  >Roles:
                  <span class="card-list-item-value">
                    {{ getRolesLabel(usuario) }}
                  </span>
                </span>
                <span class="card-list-item-label"
                  >Registro:
                  <span class="card-list-item-value">
                    {{ usuario.fechaCreacion | date: 'dd/MM/yyyy' }}
                  </span>
                </span>
                <span class="card-list-item-label"
                  >Estado usuario:
                  <span class="card-list-item-value">{{ usuario.estado }}</span>
                </span>
                <span class="card-list-item-label"
                  >Estado empresa:
                  <span class="card-list-item-value">{{
                    usuario.estadoEmpresa || 'Sin empresa'
                  }}</span>
                </span>
              </div>
            </div>

            <div class="card-list-item-actions usuario-card-actions">
              <app-button
                type="button"
                variant="outlined"
                size="small"
                (clicked)="editarUsuario(usuario)"
              >
                <i class="fa-solid fa-pen-to-square"></i>
                Editar
              </app-button>
              <app-button
                type="button"
                variant="outlined"
                [danger]="true"
                size="small"
                (clicked)="eliminarUsuario(usuario)"
              >
                <i class="fa-solid fa-trash"></i>
                Eliminar
              </app-button>
            </div>
          </div>
        </ng-template>
      </app-card-list>
    } @else {
      <app-data-table-paginado
        [columns]="columns"
        [data]="data"
        [loading]="loadingTable"
        [page]="page"
        [pageSize]="pageSize"
        [totalItems]="totalItems"
        [pageSizeOptions]="[10, 25, 50, 100]"
        [showPagination]="true"
        [showPageSize]="true"
        [showRowHover]="true"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (sortChange)="onSort($event)"
        (action)="onAction($event)"
      />
    }
  </section>

  @if (showForm) {
    <app-modal-shell title="" [showHeader]="false" (closed)="closeForm()">
      <app-usuarios-form
        [usuario]="usuarioEditar"
        [empresas]="empresas"
        [roles]="roles"
        [serverError]="saveError"
        (saved)="onUsuarioSaved($event)"
        (cancelled)="closeForm()"
      />
    </app-modal-shell>
  }

  @if (showDeleteConfirmation) {
    <app-confirmation-modal
      title="Eliminar usuario"
      [message]="deleteMessage"
      confirmLabel="Eliminar"
      cancelLabel="Cancelar"
      successTitle="Usuario eliminado"
      errorTitle="No se pudo eliminar el usuario"
      [status]="deleteStatus"
      [processing]="deletingUsuario"
      [closeOnBackdrop]="!deletingUsuario"
      [autoClose]="deleteStatus === 'success'"
      [iconColor]="colorIcon"
      [iconBackgroundColor]="backgroundIcon"
      (confirmed)="confirmarEliminarUsuario()"
      (cancelled)="closeDeleteConfirmation()"
      (closed)="closeDeleteConfirmation()"
    />
  }
</main>
